var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"lw-button",class:[
      `lw-button--${_vm.type}`,
      { 'is-plain': _vm.plain, 'is-round': _vm.round, 'is-disabled': _vm.disabled }
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }